export default {
  namespaced: true,
  state: {
    modal: null,
    masterModal: null
  },
  getters: {
    getModal: state => state.modal,
    getMasterModal: state => state.masterModal,
  },
  mutations: {
    SET_MODAL (state, modal) {
      state.modal = modal
    },    
    SET_MASTER_MODAL (state, modal) {
      state.masterModal = modal
    }
  },
  actions: {
    
  }
};
